export default {
  responses: [
    { code: "001", reason: "Facture payée, vous pouvez fermer cette page." },
    { code: "902", reason: "Échec de réponse de la vérification 3-D Secure" },
    { code: "2001", reason: "Ticket invalide" },
    { code: "2002", reason: "Réutilisation du ticket : veuillez réessayer." },
    { code: "2003", reason: "Ticket expiré" },
    { code: "2004", reason: "Échec de la requête réseau lors du chargement initial de la page" },
  ],
}